import React from 'react'
import classnames from 'classnames'
import styles from './InputSelect.less'
import ChevronIcon from '../Icons/ChevronIcon'

class InputSelect extends React.PureComponent {

  componentDidMount() {
    const { defaultValue = { value: null }, onChange = () => { } } = this.props
    if (defaultValue.value !== null) {
      this._onChange(defaultValue.value)
    }
  }

  _onBlurHandler = () => {
    const { onBlur = () => { } } = this.props
    onBlur()
  }

  _onChangeHandler = (event) => {
    this._onChange(event.target.value)
  }

  _onChange = (value, forceChange = false) => {
    const { onChange = () => { } } = this.props
    this._dirtyClass(value)
    onChange(value)
    if (this.input && forceChange) {
      this.input.value = value
    }
  }

  _dirtyClass = (value) => {
    if (this.label){
      if (value && value != '') {
        this.label.classList.add(styles.PlaceholderWithValue)
      } else {
        this.label.classList.remove(styles.PlaceholderWithValue)
      }
    }
  }

  _getThisInput = () => {
    const { getThisInput = () => { } } = this.props
    getThisInput(this)
  }

  _renderLabel = () => {
    const { name, label, required = false, withoutStar = false, active=false } = this.props

    return (
      <label
        ref={c => this.label = c}
        htmlFor={name}
        className={classnames({
          [styles.Placeholder]: true,
          [styles.PlaceholderWithValue]: active !== false && active !== -1
        })}>
        {label}
        {required && !withoutStar &&
          <span className={classnames({
            [styles.requiredStar]: true,
          })}>*</span>
        }
      </label>
    )
  }

  render() {
    const {
      defaultValue = { value : null },
      name = '',
      type = 'text',
      label = '',
      styleName = 'light',
      formType = 'normal',
      required = false,
      withoutStar = false,
      options = [],
      active=false,
      message = '',
      isValid = true
    } = this.props

    let option = <option disabled selected value="" hidden></option>
    if (!required) option = <option value="" selected></option>

    return (
      <div
        getthisinput={this._getThisInput()}
        data-test="input-text"
        className={classnames({
          [styles.InputSelect]: true,
          [styles.InputSelectCompact]: formType === "compact"
        })}>
        {formType === "compact" && this._renderLabel()}
        <select
          ref={c => this.input = c}
          className={classnames({
            [styles.InputSelectInput]: true,
            [styles.InputSelectInvalid]: !isValid,
            [styles.InputSelectDark]: styleName === 'dark',
            [styles.InputSelectLight]: styleName === 'light'
          })}
          name={name}
          id={name}
          onBlur={this._onBlurHandler}
          onChange={this._onChangeHandler}
        >
          {option}
          {options.map((option,index) => {
            let selected = ''
            if (defaultValue && defaultValue.value === option.value) {
              selected = 'selected'
            }
            if (active!==false && active === index) {
              selected = 'selected'
            }
            return (
              <option key={`Option-${index}`} selected={selected} value={option.value}>{option.label}</option>
            )
          }

          )}
        </select>
        {formType === "normal" && this._renderLabel()}
        <div className={classnames({
          [styles.message]: true,
          [styles.messageShow]: !isValid,
        })}>
          {message}
        </div>
        <span className={classnames({
          [styles.chevron]: true,
        })}>
          <ChevronIcon />
        </span>
      </div>
    )
  }
}


export default InputSelect



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputSelect/InputSelect.jsx